import { mapStatusMessage } from './mapStatusMessage';
import { EStatus } from '../../repositories/chats/entities/message_list_item_v2/MessageListItemV2Schema';
import { TMessageListItemV2, TMessageSchema } from '../../types/messages';

export const mapMessagesV2ToMessageSchema = (message: TMessageListItemV2): TMessageSchema => {
  return {
    ...message,
    status: mapStatusMessage(message.status),
    unread: message.status !== EStatus.ReadByRecipient,
  };
};
